export const ACTION_CANCEL_APPOINTMENT = '/booking-portal/Appointment/CancelAppointment';